<template>
  <section>
    <PageTitle>{{ $domUtils.decode(dialog.title) }}</PageTitle>
    <PageContent>
      <Container>
        <div
          class="tab-item-header"
          v-if="!isPartner && isLocked"
        >
          <NoticeBox type="info" :icon-class="['fas', 'fa-lock']">
            現在、このアンケート回答は管理者によりロックされています
          </NoticeBox>
        </div>
        <ul class="answer-list">
          <li
            class="answer-list-item"
            v-for="(item, index) in items"
            :key="item.question_id"
          >
            <div class="answer">
              <h2 class="answer-title">
                <span class="answer-num">Q{{ index + 1 }}</span>
                <span class="space-r-3" v-html="$domUtils.decode($domUtils.nl2br(item.question_title))"></span>
                <span class="answer-edit-link" v-if="item.answered && !isPartner && !isLocked">
                  <router-link :to="`${showPath}#q-${index + 1}`">
                    回答を編集する
                  </router-link>
                </span>
              </h2>
              <div class="answer-body">
                <template v-if="item.answered">
                  <span class="space-r-4"></span>
                  <div class="answer-content">
                    <template v-if="item.isText">
                      <p v-html="$domUtils.clear(item.answer_text)" />
                    </template>
                    <template v-if="item.isTextarea">
                      <p
                        v-html="$domUtils.nl2br(item.answer_text_multi_line)"
                      />
                    </template>
                    <template v-if="item.isDate">
                      <p>{{ item.answer_date | formatDate }}</p>
                    </template>
                    <template v-if="item.isCheck">
                      <p
                        v-for="(option, index) in item.selectedOptions"
                        :key="option.option_id"
                        :class="{ 'space-t-3': index > 0 }"
                        v-html="$domUtils.decode($domUtils.nl2br(option.option_text))"
                      >
                      </p>
                    </template>
                    <template v-if="item.isCheckImage">
                      <ul class="imagebox-list is-4-cols">
                        <li
                          class="imagebox-list-item"
                          v-for="option in item.selectedOptions"
                          :key="option.option_id"
                        >
                          <figure class="imagebox is-rounded">
                            <div class="imagebox-content">
                              <img
                                :src="option.option_image"
                                :alt="$domUtils.decode(option.option_text)" />
                            </div>
                            <figcaption class="imagebox-footer">
                              <div class="imagebox-caption">
                                <p
                                  v-html="$domUtils.decode($domUtils.nl2br(option.option_text))"
                                >
                                </p>
                              </div>
                            </figcaption>
                          </figure>
                        </li>
                      </ul>
                    </template>
                    <template v-if="item.isImage">
                      <AnswerImages :items="item.answer_image" />
                    </template>
                  </div>
                </template>
                <template v-else-if="!isPartner && !isLocked">
                  <div class="space-x-auto">
                    <router-link
                      :to="`${showPath}#q-${index + 1}`"
                      class="button waves-effect waves-light"
                    >
                      回答する
                    </router-link>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
        <div class="text-center space-t-6">
          <router-link :to="$wcRouter.path({ name: 'question.index' })">
            {{ $store.getters['app/getMenuName']('question') }} 一覧へ
          </router-link>
        </div>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import api from '@/api/question'
import Question from '@/utils/Question'
import AnswerImages from '@/components/AnswerImages.vue'
import NoticeBox from '@/components/NoticeBox.vue'
import { formatDate } from '@/filters/format-date'
import { renderError } from '@/utils/error'

export default {
  components: {
    AnswerImages,
    NoticeBox
  },

  data() {
    return {
      dialog: { title: '', locked: false },
      items: []
    }
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'question-answer' }
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    dialogId() {
      return this.$route.params.dialogId * 1
    },
    showPath() {
      return this.$wcRouter.path({
        name: 'question.show',
        params: { dialogId: this.dialogId }
      })
    },
    isPartner() {
      return this.$store.getters['auth/isPartner']
    },
    isLocked() {
      return this.dialog.locked
    }
  },

  filters: {
    formatDate,
  },

  methods: {
    /**
     * 質問グループ取得
     */
    async fetchDialog() {
      try {
        const dialogs = await api.dialogs(this.businessId)
        for (const dialog of dialogs) {
          if (dialog.dialog_id === this.dialogId) {
            this.dialog.title = dialog.dialog_title
            this.dialog.locked = dialog.locked
            return false
          }
        }
      } catch(err) {
        renderError(err)
      }
    },
    /**
     * 質問の一覧を取得
     */
    async fetchQuestions() {
      try {
        const response = await api.questions(this.businessId, this.dialogId)

        this.items = response.map(res => new Question(res))
      } catch(err) {
        renderError(err)
      }
    },
  },

  created() {
    this.$withLoading(() => Promise.all([
      this.fetchDialog(),
      this.fetchQuestions()
    ]))
  }
}
</script>
